import { lazy } from 'react';

const Dashboard = lazy(() => import('../views/dashboard/Dashboard'));

//Orders
const ListOrders = lazy(() => import('../views/orders/ListOrders'));
const DetailOrder = lazy(() => import('../views/orders/DetailOrder'));

//Users
const ListUsers = lazy(() => import('../views/users/ListUsers'));
const FormUser = lazy(() => import('../views/users/FormUser'));

//Pix Cash Ins
const ListPixCashIns = lazy(() => import('../views/pix-cash-ins/ListPixCashIns'));
const DetailPixCashIn = lazy(() => import('../views/pix-cash-ins/DetailPixCashIn'));

//Pix Infractions
const ListPixInfractions = lazy(() => import('../views/pix-infractions/ListPixInfractions'));
const DetailPixInfraction = lazy(() => import('../views/pix-infractions/DetailPixInfraction'));

//Currencies
const ListCurrencies = lazy(() => import('../views/currencies/ListCurrencies'));
const FormCurrency = lazy(() => import('../views/currencies/FormCurrency'));

//Customers
const ListCustomers = lazy(() => import('../views/customers/ListCustomers'));
const FormCustomer = lazy(() => import('../views/customers/FormCustomer'));
const DetailCustomer = lazy(() => import('../views/customers/DetailCustomer'));
const FormApiCredentials = lazy(() => import('../views/customers/FormApiCredentials'));
const FormProviderCredentials = lazy(() => import('../views/customers/FormProviderCredentials'));
const FormCustomerPlans = lazy(() => import('../views/customers/FormCustomerPlans'));

//Wallets
const ListWallets = lazy(() => import('../views/wallets/ListWallets'));
const FormWallet = lazy(() => import('../views/wallets/FormWallet'));
const DetailWallet = lazy(() => import('../views/wallets/DetailWallet'));

//Networks
const ListNetworks = lazy(() => import('../views/networks/ListNetworks'));
const FormNetwork = lazy(() => import('../views/networks/FormNetwork'));

//Payers
const ListPayers = lazy(() => import('../views/payers/ListPayers'));
const FormPayer = lazy(() => import('../views/payers/FormPayer'));
const DetailPayer = lazy(() => import('../views/payers/DetailPayer'));

//OTC Orders
const ListOtcOrders = lazy(() => import('../views/otc_orders/ListOtcOrders'));
const DetailOtcOrder = lazy(() => import('../views/otc_orders/DetailOtcOrder'));

//OTC Payments
const ListOtcPayments = lazy(() => import('../views/otc_payments/ListOtcPayments'));
const DetailOtcPayment = lazy(() => import('../views/otc_payments/DetailOtcPayment'));

//OTC Order Transfers
const ListOtcOrderTransfers = lazy(
  () => import('../views/otc_order_transfers/ListOtcOrderTransfers'),
);
const DetailOtcOrderTransfer = lazy(
  () => import('../views/otc_order_transfers/DetailOtcOrderTransfer'),
);

//OTC Payment Transfers
const ListOtcPaymentTransfers = lazy(
  () => import('../views/otc_payment_transfers/ListOtcPaymentTransfers'),
);
const DetailOtcPaymentTransfer = lazy(
  () => import('../views/otc_payment_transfers/DetailOtcPaymentTransfer'),
);

//Pix Cash Outs
const ListPixCashOuts = lazy(() => import('../views/pix-cash-outs/ListPixCashOuts'));
const DetailPixCashOut = lazy(() => import('../views/pix-cash-outs/DetailPixCashOut'));

//Tiers
const ListTiers = lazy(() => import('../views/tiers/ListTiers'));
const FormTier = lazy(() => import('../views/tiers/FormTier'));
const DetailTier = lazy(() => import('../views/tiers/DetailTier'));
const ListCustomerAccessBlocks = lazy(
  () => import('../views/customer-access-blocks/ListCustomerAccessBlocks'),
);
const ListCustomerAccessAttempts = lazy(
  () => import('../views/customer-access-attempts/ListCustomerAccessAttempts'),
);
const ListCustomerAccessGroups = lazy(
  () => import('../views/customer-access-groups/ListCustomerAccessGroups'),
);
const ListCustomerAccessCidrSuggestions = lazy(
  () => import('../views/customer-access-cidr-suggestions/ListCustomerAccessCidrSuggestions'),
);
const ListCustomerAccessAlerts = lazy(
  () => import('../views/customer-access-alerts/ListCustomerAccessAlerts'),
);

//Configurations
const ListConfigurations = lazy(() => import('../views/configuration/ListConfigurations'));
const FormConfiguration = lazy(() => import('../views/configuration/FormConfiguration'));
const DetailConfiguration = lazy(() => import('../views/configuration/DetailConfiguration'));
const OtcScheduleConfiguration = lazy(
  () => import('../views/configuration/OtcScheduleConfiguration'),
);

//Withdrawals
const ListWithdrawals = lazy(() => import('../views/withdrawals/ListWithdrawals'));
const DetailWithdrawal = lazy(() => import('../views/withdrawals/DetailWithdrawal'));

//Contracts
const ListContracts = lazy(() => import('../views/contracts/ListContracts'));
const FormContract = lazy(() => import('../views/contracts/FormContract'));
const DetailContract = lazy(() => import('../views/contracts/DetailContract'));

//QuoteAccessToken
const ListQuoteAccessToken = lazy(() => import('../views/quote-access-token/ListQuoteAccessToken'));
const FormQuoteAccessToken = lazy(() => import('../views/quote-access-token/FormQuoteAccessToken'));
const DetailQuoteAccessToken = lazy(
  () => import('../views/quote-access-token/DetailQuoteAccessToken'),
);

//BankWebhooks
const ListBankWebhooks = lazy(() => import('../views/bank-webhooks/ListBankWebhooks'));
const FormBankWebhook = lazy(() => import('../views/bank-webhooks/FormBankWebhook'));
const DetailBankWebhook = lazy(() => import('../views/bank-webhooks/DetailBankWebhook'));

//Bank Pix Cash Ins
const ListBankPixCashIns = lazy(() => import('../views/bank-pix-cash-ins/ListBankPixCashIns'));
const DetailBankPixCashIn = lazy(() => import('../views/bank-pix-cash-ins/DetailBankPixCashIn'));

const Page403 = lazy(() => import('../views/pages/Page403'));

const routes = [
  { path: '/', exact: true, name: 'Home' },
  {
    path: '/dashboard',
    name: 'Dashboard',
    element: Dashboard,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },

  {
    path: '/orders',
    name: 'Orders',
    element: ListOrders,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/orders/list-orders',
    name: 'List',
    element: ListOrders,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/orders/details-order',
    name: 'Details',
    element: DetailOrder,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },

  { path: '/users', name: 'Users', element: ListUsers, exact: true, role: ['ADMIN', 'USER'] },
  { path: '/users/list-users', name: 'List', element: ListUsers, role: ['ADMIN', 'USER'] },
  { path: '/users/edit-user', name: 'Edit', element: FormUser, role: ['ADMIN'] },
  { path: '/users/add-user', name: 'New', element: FormUser, role: ['ADMIN'] },

  {
    path: '/pix-cash-ins',
    name: 'Pix Cash Ins',
    element: ListPixCashIns,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/pix-cash-ins/list-pix-cash-ins',
    name: 'List',
    element: ListPixCashIns,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/pix-cash-ins/details-pix-cash-in',
    name: 'Details',
    element: DetailPixCashIn,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },

  {
    path: '/pix-infractions',
    name: 'Pix Infractions',
    element: ListPixInfractions,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/pix-infractions/list-pix-infractions',
    name: 'List',
    element: ListPixInfractions,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/pix-infractions/details-pix-infraction',
    name: 'Details',
    element: DetailPixInfraction,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },

  {
    path: '/currencies',
    name: 'Currencies',
    element: ListCurrencies,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/currencies/list-currencies',
    name: 'List',
    element: ListCurrencies,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  { path: '/currencies/edit-currency', name: 'Edit', element: FormCurrency, role: ['ADMIN'] },
  { path: '/currencies/add-currency', name: 'New', element: FormCurrency, role: ['ADMIN'] },

  {
    path: '/customers',
    name: 'Customers',
    element: ListCustomers,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customers/list-customers',
    name: 'List',
    element: ListCustomers,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  { path: '/customers/edit-customer', name: 'Edit', element: FormCustomer, role: ['ADMIN'] },
  { path: '/customers/add-customer', name: 'New', element: FormCustomer, role: ['ADMIN'] },
  {
    path: '/customers/details-customer',
    name: 'Details',
    element: DetailCustomer,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customers/add-api-credential',
    name: 'Add API Credential',
    element: FormApiCredentials,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customers/edit-api-credential',
    name: 'Edit API Credential',
    element: FormApiCredentials,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customers/add-provider-credential',
    name: 'Add Provider Credential',
    element: FormProviderCredentials,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customers/edit-provider-credential',
    name: 'Edit Provider Credential',
    element: FormProviderCredentials,
    role: ['ADMIN'],
  },
  {
    path: '/customers/add-customer-plan',
    name: 'Add Customer Plan',
    element: FormCustomerPlans,
    role: ['ADMIN'],
  },
  {
    path: '/customers/edit-customer-plan',
    name: 'Edit Customer Plan',
    element: FormCustomerPlans,
    role: ['ADMIN'],
  },

  {
    path: '/wallets',
    name: 'Wallets',
    element: ListWallets,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/wallets/list-wallets',
    name: 'List',
    element: ListWallets,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  { path: '/wallets/edit-wallet', name: 'Edit', element: FormWallet, role: ['ADMIN'] },
  { path: '/wallets/add-wallet', name: 'New', element: FormWallet, role: ['ADMIN'] },
  {
    path: '/wallets/details-wallet',
    name: 'Details',
    element: DetailWallet,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },

  {
    path: '/networks',
    name: 'Networks',
    element: ListNetworks,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/networks/list-networks',
    name: 'List',
    element: ListNetworks,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  { path: '/networks/edit-network', name: 'Edit', element: FormNetwork, role: ['ADMIN'] },
  { path: '/networks/add-network', name: 'New', element: FormNetwork, role: ['ADMIN'] },

  {
    path: '/payers',
    name: 'Payers',
    element: ListPayers,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/payers/list-payers',
    name: 'List',
    element: ListPayers,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  { path: '/payers/edit-payer', name: 'Edit', element: FormPayer, role: ['ADMIN'] },
  { path: '/payers/details-payer', name: 'Details', element: DetailPayer, role: ['ADMIN'] },

  {
    path: '/otc_orders',
    name: 'OTC Orders',
    element: ListOtcOrders,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/otc_orders/list-otc-orders',
    name: 'List',
    element: ListOtcOrders,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/otc_orders/details-otc-order',
    name: 'Details',
    element: DetailOtcOrder,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },

  {
    path: '/otc_payments',
    name: 'OTC Payments',
    element: ListOtcPayments,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/otc_payments/list-otc-payments',
    name: 'List',
    element: ListOtcPayments,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/otc_payments/details-otc-payment',
    name: 'Details',
    element: DetailOtcPayment,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  //
  {
    path: '/otc_order_transfers',
    name: 'OTC Order Transfers',
    element: ListOtcOrderTransfers,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/otc_order_transfers/list-otc-order-transfers',
    name: 'List',
    element: ListOtcOrderTransfers,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/otc_order_transfers/details-otc-order-transfer',
    name: 'Details',
    element: DetailOtcOrderTransfer,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },

  {
    path: '/otc_payment_transfers',
    name: 'OTC Payment Transfers',
    element: ListOtcPaymentTransfers,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/otc_payment_transfers/list-otc-payment-transfers',
    name: 'List',
    element: ListOtcPaymentTransfers,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/otc_payment_transfers/details-otc-payment-transfer',
    name: 'Details',
    element: DetailOtcPaymentTransfer,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },

  {
    path: '/pix-cash-outs',
    name: 'Pix Cash Outs',
    element: ListPixCashOuts,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/pix-cash-outs/list-pix-cash-outs',
    name: 'List',
    element: ListPixCashOuts,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/pix-cash-outs/details-pix-cash-out',
    name: 'Details',
    element: DetailPixCashOut,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },

  {
    path: '/tiers',
    name: 'Tiers',
    element: ListTiers,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/tiers/list-tiers',
    name: 'List',
    element: ListTiers,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  { path: '/tiers/edit-tier', name: 'Edit', element: FormTier, role: ['ADMIN'] },
  { path: '/tiers/add-tier', name: 'New', element: FormTier, role: ['ADMIN'] },
  { path: '/tiers/details-tier', name: 'Details', element: DetailTier, role: ['ADMIN'] },
  {
    path: '/customer-access-blocks',
    name: 'IP Blocks',
    element: ListCustomerAccessBlocks,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customer-access-blocks/list-customer-access-blocks',
    name: 'List',
    element: ListCustomerAccessBlocks,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customer-access-attempts',
    name: 'IP Attempts',
    element: ListCustomerAccessAttempts,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customer-access-attempts/list-customer-access-attempts',
    name: 'List',
    element: ListCustomerAccessAttempts,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customer-access-groups',
    name: 'IP Attack Monitor',
    element: ListCustomerAccessGroups,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customer-access-groups/list-customer-access-groups',
    name: 'List',
    element: ListCustomerAccessGroups,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customer-access-cidr-suggestions',
    name: 'CIDR Suggestions',
    element: ListCustomerAccessCidrSuggestions,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customer-access-cidr-suggestions/list-customer-access-cidr-suggestions',
    name: 'List',
    element: ListCustomerAccessCidrSuggestions,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customer-access-alerts',
    name: 'IP Alerts',
    element: ListCustomerAccessAlerts,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/customer-access-alerts/list-customer-access-alerts',
    name: 'List',
    element: ListCustomerAccessAlerts,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },

  {
    path: '/configs',
    name: 'Configurations',
    element: ListConfigurations,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/configs/list-configs',
    name: 'List',
    element: ListConfigurations,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/configs/otc-schedule',
    name: 'OTC Schedule',
    element: OtcScheduleConfiguration,
    role: ['ADMIN', 'USER'],
  },
  { path: '/configs/edit-config', name: 'Edit', element: FormConfiguration, role: ['ADMIN'] },
  { path: '/configs/add-config', name: 'New', element: FormConfiguration, role: ['ADMIN'] },
  {
    path: '/configs/details-config',
    name: 'Details',
    element: DetailConfiguration,
    role: ['ADMIN'],
  },
  //WITHDRAWALS
  {
    path: '/withdrawals',
    name: 'Withdrawals',
    element: ListWithdrawals,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/withdrawals/list-withdrawals',
    name: 'List',
    element: ListWithdrawals,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/withdrawals/details-withdrawal',
    name: 'List',
    element: DetailWithdrawal,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },

  //CONTRACTS
  {
    path: '/contracts',
    name: 'Contracts',
    element: ListContracts,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/contracts/list-contracts',
    name: 'List',
    element: ListContracts,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  { path: '/contract/add-contract', name: 'Add', element: FormContract, role: ['ADMIN'] },
  { path: '/contracts/edit-contract', name: 'Edit', element: FormContract, role: ['ADMIN'] },
  {
    path: '/contracts/details-contract',
    name: 'Details',
    element: DetailContract,
    role: ['ADMIN'],
  },

  { path: '/access-denied', name: 'Access Denied', element: Page403, exact: true },

  {
    path: '/quote-access-token',
    name: 'Quote Access Token',
    element: ListQuoteAccessToken,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/quote-access-token/list-quote-access-token',
    name: 'List',
    element: ListQuoteAccessToken,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/quote-access-token/edit-quote-access-token',
    name: 'Edit',
    element: FormQuoteAccessToken,
    role: ['ADMIN'],
  },
  {
    path: '/quote-access-token/add-quote-access-token',
    name: 'New',
    element: FormQuoteAccessToken,
    role: ['ADMIN'],
  },
  {
    path: '/quote-access-token/details-quote-access-token',
    name: 'Details',
    element: DetailQuoteAccessToken,
    role: ['ADMIN'],
  },
  //BankWebhooks
  {
    path: '/bank-webhooks',
    name: 'Bank Webhooks',
    element: ListBankWebhooks,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/bank-webhooks/list-bank-webhooks',
    name: 'List',
    element: ListBankWebhooks,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/bank-webhooks/edit-bank-webhook',
    name: 'Edit',
    element: FormBankWebhook,
    role: ['ADMIN'],
  },
  {
    path: '/bank-webhooks/add-bank-webhook',
    name: 'New',
    element: FormBankWebhook,
    role: ['ADMIN'],
  },
  {
    path: '/bank-webhooks/details-bank-webhook',
    name: 'Details',
    element: DetailBankWebhook,
    role: ['ADMIN'],
  },

  {
    path: '/bank-pix-cash-ins',
    name: 'Bank Pix Cash Ins',
    element: ListBankPixCashIns,
    exact: true,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/bank-pix-cash-ins/list-bank-pix-cash-ins',
    name: 'List',
    element: ListBankPixCashIns,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    path: '/bank-pix-cash-ins/details-bank-pix-cash-in',
    name: 'Details',
    element: DetailBankPixCashIn,
    role: ['ADMIN', 'USER', 'ANALYZE'],
  },
];

export default routes;
